'use client';

import H2 from '@/components/typography/h2';
import { CopiableEmail } from '@/components/ui/copiable';
import { useTranslation } from 'react-i18next';

export default function Questions() {
    const { t } = useTranslation();

    return (
        <div className="border-primary mb-10 border-b lg:mb-0">
            <div className="mb-[24rem] flex w-full px-4 lg:mb-[12rem] lg:ml-0 lg:justify-center">
                <H2
                    className="w-full text-center lg:max-w-[78.1875rem]"
                    variant="small"
                >
                    {t('questions.title')}&nbsp;
                    <CopiableEmail
                        label="Email Sebastiaan"
                        email={t('questions.email')}
                    />
                </H2>
            </div>
        </div>
    );
}
